/* RSK9 reveals — IntersectionObserver-driven scroll reveals + counter animations. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initReveals() {
    var els = document.querySelectorAll('.rsk9-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rsk9-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rsk9-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function animateCounter(el) {
    var target = parseFloat(el.dataset.rsk9Counter || '0');
    var prefix = el.dataset.rsk9Prefix || '';
    var suffix = el.dataset.rsk9Suffix || '';
    var duration = parseInt(el.dataset.rsk9Duration || '2200', 10);
    var startTs = null;
    function tick(ts) {
      if (!startTs) startTs = ts;
      var progress = Math.min((ts - startTs) / duration, 1);
      var v = target * easeOutQuart(progress);
      el.textContent = prefix + Math.round(v) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters() {
    var nodes = document.querySelectorAll('[data-rsk9-counter]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(animateCounter);
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });
    nodes.forEach(function (n) { obs.observe(n); });
  }

  function init() {
    // Gate: tell CSS that JS is here, so the .rsk9-reveal hide-rule activates.
    // Without this, reveals never hide and content is always visible — a graceful
    // fallback if JS fails to load.
    document.documentElement.classList.add('rsk9-js-ready');
    initReveals();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
